import Vue from 'vue'
import Vuex from 'vuex'

import i18n from '@/store/app/i18n'
import theme from '@/store/app/theme'
import auth from '@/store/app/auth'
import cabinet from "@/store/cabinet";
import space from '@/store/space'
import reports from "@/store/reports";
import moneyDashboard from "@/store/moneyDashboard";
import investments from '@/store/investments'

Vue.use(Vuex);

const debug = process.env.NODE_ENV !== "production";

export default new Vuex.Store({
    strict: debug,
    actions: {
        clearCabinetDependencies({commit,dispatch}) {
            commit('space/accounts/clearAccounts');
            commit('space/expenses/clearExpenses');
            commit('space/incomes/clearIncomes');
            commit('space/contractors/clearContractors');
            commit('space/tags/clearTags');
            commit('space/access/clearSpaceMembers');
            commit('space/transactions/clearTransactions');
            commit('space/transactions/clearFilters');
            commit('space/budgets/clearBudgets');
            commit('space/budgets/setSelectedBudget', null);
            commit('space/budgets/setDateFilter', null);
            commit('space/goals/clearGoals');
            commit('space/banks/clearProviders');
            dispatch('space/calendar/resetCalendar');
            commit('moneyDashboard/budgetWidget/clearBudgetsWidget');
            commit('moneyDashboard/recentTransactions/clearRecentTransactions');
            commit('moneyDashboard/plannedTransactions/clearPlannedTransactions');
            commit('investments/portfolios/clearPortfolios');
            commit('reports/report_filters/clearFilters');
        }
    },
    modules: {
        i18n,
        theme,
        auth,

        cabinet,
        space,
        moneyDashboard,
        investments,
        reports,
    }
})